"use client";

import { SectionFrame } from "@/components/ui/section-frame";
import { useScrollColumnReveal } from "@/hooks/use-scroll-column-reveal";

export function TeachersSection() {
  const { ref, inView, leftRotate, rightRotate, opacity } = useScrollColumnReveal();

  return (
    <div data-testid="teachers-section">
      <SectionFrame
        startColor="rgb(var(--cta-yellow-bright))"
        endColor="rgb(var(--cta-orange))"
        flipped={true}
        clipOverflowX={false}
        contentClassName="py-16"
      >
        {/* Observe the columns (not the SVG borders) so the reveal starts
            when the copy/art enter the trigger band — not off-screen. */}
        <div
          ref={ref}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center"
          data-in-view={inView ? "true" : "false"}
        >
          {/* Left Column - Icon and Text: pivot bottom-right, swings in from left */}
          <div
            className="flex flex-col items-start text-left origin-bottom-right will-change-transform"
            data-testid="teachers-copy"
            style={{ transform: `rotate(${leftRotate}deg)`, opacity }}
          >
            <img
              src="/images/marketing/home/teacher/apple-icon.svg"
              alt="Apple icon"
              className="w-12 h-12 lg:w-16 lg:h-16 mb-4"
            />
            <h2 className="text-2xl md:text-3xl lg:text-4xl text-black mb-6">
              Kid-loved, teacher-approved
            </h2>
            <p className="text-black/90 text-lg lg:text-xl/8 mb-6">
              Play-based learning is one of the most effective ways to combine engagement with
              education. Kids love it because it&apos;s genuinely fun, and grownups love it because
              it&apos;s educational. There are no mindless, junk games, nor are there boring,
              gamified worksheets. At PlayMath.org, we care about mathy game<strong>play</strong>,
              where the play <strong>is</strong> the learning.
            </p>
            <a
              href="https://www.frontiersin.org/journals/psychology/articles/10.3389/fpsyg.2024.1307881/full"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black/70 text-base lg:text-lg hover:text-black underline"
            >
              Read the research on the efficacy of play-based learning ➜
            </a>
          </div>

          {/* Right Column - Art: pivot bottom-left, swings in from right */}
          <div
            className="flex justify-center lg:justify-end origin-bottom-left will-change-transform"
            data-testid="teachers-art"
            style={{ transform: `rotate(${rightRotate}deg)`, opacity }}
          >
            <img
              src="/images/marketing/home/teacher/teacher-sitting-art.webp"
              alt="Teacher sitting illustration"
              className="w-full max-w-md lg:max-w-lg xl:max-w-xl"
            />
          </div>
        </div>
      </SectionFrame>
    </div>
  );
}

export default TeachersSection;
